import { useEffect, useState, useRef } from "react";
import { env } from "../config";

function HomeIntro({ HomepageTitleContent }: any) {
  const [videoUrl, setVideoUrl] = useState<string | null>(null);
  const [videoPlayed2s, setVideoPlayed2s] = useState(false);
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    fetch(`${env}/api/banner-videos?populate=deep`)
      .then((res) => res.json())
      .then((data) => {
        const url =
          data?.data?.[0]?.attributes?.BannerVideo?.data?.attributes?.url;
        if (url) {
          setVideoUrl(env + url);
        }
      })
      .catch(() => {
        setVideoUrl(null);
      });
  }, []);

  // Listen for video progress
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleTimeUpdate = () => {
      if (video.currentTime >= 1) {
        setVideoPlayed2s(true);
      }
    };

    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => video.removeEventListener("timeupdate", handleTimeUpdate);
  }, [videoRef, videoUrl]);

  return (
    <div className="relative w-full overflow-hidden">
      {/* Hero Image = LCP candidate */}
      <img
        src="https://imagedelivery.net/pN4U1Bz5oPlEGJO_1sM7lw/0471ac60-bc08-43b3-27ca-dab75d0f1400/high"
        alt="Hero"
        width={1025}
        height={576}
        className="w-screen h-auto"
        // @ts-expect-error - fetchPriority not yet in React types
        fetchPriority="high"
        decoding="sync"
      />

      {/* Video Layer (sits on top of image) */}
      {videoUrl && (
        <video
          ref={videoRef}
          className="absolute inset-0 w-screen h-auto z-10"
          src={videoUrl}
          autoPlay
          loop
          muted
          playsInline
        />
      )}

      {/* Overlay Text - only show after 2 seconds of playback */}
      {videoPlayed2s && (
        <div
          className="absolute inset-0 z-20 flex items-center justify-center aos-init aos-animate bg-[#F7941E26]"
          data-aos="fade-up"
        >
          <div className="text-white font-custom font-bold text-2xl sm:text-3xl md:text-4xl xl:text-5xl text-center max-w-5xl px-4 md:px-8 py-12 flex flex-col gap-4">
            <p className="leading-[125%]">
              {HomepageTitleContent?.HomepageTitle}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomeIntro;
